import { Dialog } from "./dialog";
import { Tabs } from "./tabs";

const SELECTORS = {
  dialogTab: ".js-dialog-tab",
  dialogMask: ".js-dialog-mask",
};

class DialogTabs {
  constructor(context) {
    this.context = context;
    this.dialog = null;
    this.tabs = null;
  }

  getAssociatedDialogTrigger(tabUid) {
    const dialogTrigger = this.dialog.dialogTriggers.filter(
      (trigger) => trigger.dataset.dialogTab === tabUid,
    );

    if (dialogTrigger.length > 0) {
      return dialogTrigger[0];
    }

    return null;
  }

  init() {
    this.mask = this.context.querySelector(SELECTORS.dialogMask);
    this.tabs = new Tabs(this.context, SELECTORS.dialogTab, this.mask);
    this.dialog = new Dialog(this.context);

    this.tabs.init();
    this.dialog.init();

    this.subscribe();
  }

  subscribe() {
    this.dialog.dialogTriggers.forEach((trigger) => {
      trigger.addEventListener("click", (event) => {
        const { dialogTab } = event.currentTarget.dataset;
        const currentTab = this.tabs.getAssociatedTab(dialogTab);

        this.tabs.toggleTab(currentTab);
        this.tabs.animateTabpanel(currentTab);
      });
    });

    this.tabs.onToggle((instance, element) => {
      const dialogTab = element.dataset.tab;
      const dialogTabTrigger = this.getAssociatedDialogTrigger(dialogTab);

      this.dialog.focusTrap.set("focusBackElement", dialogTabTrigger);
    });
  }
}

export { DialogTabs };
